import { Tab, Tabs, Typography } from "@mui/material";
import DashboardCards from "../../components/dashboard-card";

const Dashboard = () => {        

    return <div>
        <div className="w-full border-divider flex flex-row items-center justify-center mb-3">
            <Tabs value={0} sx={{ color: 'black' }}>
                <Tab style={{ fontWeight: 550, fontSize: 15, color: 'black' }} label={<Typography className="text-gray-700 dark:text-gray-300 mb-2 font-bold">Dashboard Agentes</Typography>} wrapped />
            </Tabs>
        </div>
        <div className="w-full bg-white dark:bg-gray-800 shadow-lg rounded-lg min-h-[700px] p-10">
            <DashboardCards />
        </div>
    </div>
}

export default Dashboard;